var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.4C14.5313 17.4 16.5833 15.3853 16.5833 12.9C16.5833 10.4147 14.5313 8.39996 12 8.39996C9.46866 8.39996 7.41663 10.4147 7.41663 12.9C7.41663 15.3853 9.46866 17.4 12 17.4Z",
    fill: "#373737"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1666 5.7H18.2595C17.892 5.7 17.5469 5.55939 17.2869 5.3045L15.6111 3.65918C15.1783 3.23423 14.6027 3 13.9904 3H10.0095C9.39722 3 8.82161 3.23423 8.38879 3.65918L6.71302 5.3045C6.45297 5.55939 6.10789 5.7 5.74042 5.7H2.83334C1.8222 5.7 1 6.50726 1 7.49998V19.2C1 20.1927 1.8222 21 2.83334 21H21.1666C22.1777 21 23 20.1927 23 19.2V7.49998C22.9999 6.50726 22.1777 5.7 21.1666 5.7ZM12 18.3C8.9671 18.3 6.49998 15.8777 6.49998 12.9C6.49998 9.92226 8.9671 7.49998 12 7.49998C15.0328 7.49998 17.4999 9.92226 17.4999 12.9C17.4999 15.8777 15.0328 18.3 12 18.3ZM19.3333 10.2C18.828 10.2 18.4166 9.79612 18.4166 9.3C18.4166 8.80387 18.828 8.40001 19.3333 8.40001C19.8386 8.40001 20.2499 8.80387 20.2499 9.3C20.2499 9.79612 19.8386 10.2 19.3333 10.2Z",
    fill: "#373737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.7f59292ea8565220eba13dc66f537286.svg";
export { ForwardRef as ReactComponent };